const descriptionLines = [
  {
    id: 1,
    styles: {
      height: '34px',
      width: '40%',
    },
  },
  {
    id: 2,
    styles: {
      height: '28px',
      width: '30%',
    },
  },
  {
    id: 3,
    styles: {
      height: '14px',
      width: '55%',
    },
  },
  {
    id: 4,
    styles: {
      height: '14px',
      width: '60%',
    },
  },
  {
    id: 5,
    styles: {
      height: '14px',
      width: '70%',
    },
  },
  {
    id: 6,
    styles: {
      height: '14px',
      width: '62%',
    },
  },
]
export default function PlaceholderResort() {
  return (<div className='resort_placeholder placeholder-animation'>
    <div className='resort_placeholder__info'>
      <div className='resort_placeholder__image' style={{ }} />
      <div className='resort_placeholder__description'>
        <div className='resort_placeholder__text'>
          {
            descriptionLines.map(item => {
              return (<div key={item.id} style={item.styles} className='resort_placeholder__line' />)
            })
          }
        </div>
        <div className='resort_placeholder__price'>
          <div className='resort_placeholder__line' style={{ width: '80%', height: '24px' }} />
          <div className='resort_placeholder__line gray' style={{ width: '90%', height: '48px' }} />
        </div>
      </div>
    </div>
  </div>)
}
